import { render, staticRenderFns } from "./DemandRoom.vue?vue&type=template&id=5969af3c&scoped=true&"
import script from "./DemandRoom.vue?vue&type=script&lang=js&"
export * from "./DemandRoom.vue?vue&type=script&lang=js&"
import style0 from "./DemandRoom.vue?vue&type=style&index=0&id=5969af3c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5969af3c",
  null
  
)

export default component.exports